module.exports = __webpack_public_path__ + "img/mockBg.260246e4.png";